// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"LY-z","sponsoredTooltipWrapper":"MY-z","sponsoredTooltip":"NY-z","newCard":"OY-z"};